export { default } from '@shikijs/langs/csharp'
